export const objectToQueryString = (obj) => {
  // Mapeia cada chave-valor do objeto para o formato chave=valor e concatena com &
  return Object.keys(obj)
    .map(key => {
      // Se o valor for um array, junta os elementos com vírgula
      const value = Array.isArray(obj[key]) ? obj[key].join(',') : obj[key];
      return `${(key)}=${(value)}`;
    })
    .join('&');
};